/**
 * The fail-closed path `FE-07` requires: a missing or malformed runtime configuration renders a
 * visible error and never mounts the application against a guessed or defaulted origin.
 *
 * Extracted out of `main.tsx` for the reason `docs/TESTING-STANDARDS.md` states under "Seams" -
 * the same split `mount-point.ts` makes for locating the mount point. Plain DOM text rather than a
 * rendered React tree: this path exists precisely because something upstream of the application
 * failed, so it must not depend on the application's own render stack, the design system's CSS
 * having loaded, or anything else that could be part of what just broke.
 */
export function renderBootstrapError(
  container: { textContent: string | null },
  message: string,
): void {
  container.textContent = `Configuration error: ${message}`;
}
